<template>
  <div v-if="notification && notification.message && notification.message.length">
    <b-alert show dismissible :variant="typeClass">
      <!-- <strong class="alert-heading">{{ notificationTitle }}</strong> -->
      <p class="m-0">{{ notification.message }}</p>
    </b-alert>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AppConstants from "@/appConstants.js";
export default {
  name: "NotificationMessage",
  props: {
    notification: Object,
  },
  data() {
    return {
      timeout: null,
    };
  },
  methods: {
    ...mapActions(["removeNotification"]),
  },
  computed: {
    typeClass() {
      return `${this.notification.type}`.toLowerCase();
    },
    notificationTitle() {
      return `${this.notification.type}`;
    },
  },
  created() {
    this.timeout = setTimeout(() => {
      this.removeNotification(this.notification);
    }, AppConstants.NOTIFICATION_TIMEOUT_TIME);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
};
</script>

<style></style>
